import React from "react";
import { Row, Badge, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import ButtonSendActivationMail from "../Button/ButtonSendActivationMail";

export default function FoundUserInfo(props) {
  if (props.foundUser.UserFound !== false) {
    return (
      <Row>
        <Col xs="12">
          <div
            className="card card-body mt-3"
            style={{
              width: "50%",
              textDecorationLine: props.foundUser.IsDeleted
                ? "line-through"
                : "none",
            }}
          >
            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Id" />
              </p>
              <p
                className="float-start ms-2"
                style={{
                  textDecorationLine: props.foundUser.IsDeleted
                    ? "line-through"
                    : "none",
                }}
              >
                {props.foundUser.Id}
              </p>
              {!props.foundUser.Activated && !props.foundUser.IsDeleted && (
                <div className="col ms-auto">
                  <ButtonSendActivationMail
                    user={{ email: props.foundUser.Email }}
                    printButtonText={true}
                  />
                </div>
              )}
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Created" />:
              </p>
              <p
                className="float-start ms-2"
                style={{
                  textDecorationLine: props.foundUser.IsDeleted
                    ? "line-through"
                    : "none",
                }}
              >
                {props.foundUser.Created}
              </p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="IsDeleted" />:
              </p>
              <p className="float-start ms-2">
                {props.foundUser.IsDeleted ? (
                  <FormattedMessage id="true" />
                ) : (
                  <FormattedMessage id="false" />
                )}
              </p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Activated" />:
              </p>
              <p
                className="float-start ms-2"
                style={{
                  textDecorationLine: props.foundUser.IsDeleted
                    ? "line-through"
                    : "none",
                }}
              >
                {props.foundUser.Activated ? (
                  <FormattedMessage id="true" />
                ) : (
                  <FormattedMessage id="false" />
                )}
              </p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Name" />:
              </p>
              <p
                className="float-start ms-2"
                style={{
                  textDecorationLine: props.foundUser.IsDeleted
                    ? "line-through"
                    : "none",
                }}
              >
                {props.foundUser.Name}
              </p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Type" />:
              </p>
              <p
                className="float-start ms-2"
                style={{
                  textDecorationLine: props.foundUser.IsDeleted
                    ? "line-through"
                    : "none",
                }}
              >
                {props.foundUser.Type}
              </p>
            </div>

            {props.foundUser.Type === "Teacher" ? (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="FullTeacherAccess" />:{" "}
                </p>
                <p
                  className="float-start ms-2"
                  style={{
                    textDecorationLine: props.foundUser.IsDeleted
                      ? "line-through"
                      : "none",
                  }}
                >
                  {props.foundUser.HasFullTeacherAccess ? (
                    <FormattedMessage id="true" />
                  ) : (
                    <FormattedMessage id="false" />
                  )}
                </p>
              </div>
            ) : (
              ""
            )}

            {props.foundUser.Type === "Teacher" ? (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="IsPurchaser" />:{" "}
                </p>
                <p
                  className="float-start ms-2"
                  style={{
                    textDecorationLine: props.foundUser.IsDeleted
                      ? "line-through"
                      : "none",
                  }}
                >
                  {props.foundUser.IsPurchaser ? (
                    <FormattedMessage id="true" />
                  ) : (
                    <FormattedMessage id="false" />
                  )}
                </p>
              </div>
            ) : (
              ""
            )}

            {props.foundUser.Type !== "Superuser" &&
            props.foundUser.Type !== "Admin" ? (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3">
                  {props.foundUser.Schools.length > 1 ? (
                    <FormattedMessage id="Schools" />
                  ) : (
                    <FormattedMessage id="School" />
                  )}
                </p>
                {props.foundUser.Schools.map(function (school, index) {
                  return (
                    <span
                      className={index === 0 ? "ms-2" : ""}
                      key={`class_${index}`}
                    >
                      {(index ? ", " : "") + school.name + " ("}
                      <FormattedMessage id="FortnoxNumber" />{" "}
                      {": " + school.fortNoxNumber + ")"}
                    </span>
                  );
                })}
              </div>
            ) : (
              ""
            )}

            {props.foundUser.Type !== "Superuser" &&
            props.foundUser.Type !== "Admin" ? (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3">
                  {props.foundUser.Classes.length > 1 ? (
                    <FormattedMessage id="Classes" />
                  ) : (
                    <FormattedMessage id="Class" />
                  )}
                </p>
                {props.foundUser.Classes.map(function (cl, index) {
                  return (
                    <span
                      className={index === 0 ? "ms-2" : ""}
                      key={`class_${index}`}
                    >
                      {(index ? ", " : "") + cl}
                    </span>
                  );
                })}
              </div>
            ) : (
              ""
            )}

            {props.foundUser.Type === "Student" ? (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3 mb-0 pb-0">
                  <FormattedMessage id="LicenseOnSchool" />:
                </p>
                <p className="float-start ms-2">
                  {props.foundUser.LicenceOnSchool}
                </p>
              </div>
            ) : (
              ""
            )}

            {props.foundUser.Type === "Student" ? (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3 mb-0 pb-0">
                  <FormattedMessage id="AplLicenseValidTo" />:
                </p>
                <p
                  className="float-start ms-2"
                  style={{
                    textDecorationLine:
                      props.foundUser.IsDeleted ||
                      (props.foundUser.AplLicenseValidTo &&
                        props.foundUser.AplLicenseValidTo <
                          new Date().toISOString().split("T")[0])
                        ? "line-through"
                        : "none",
                  }}
                >
                  {props.foundUser.AplLicenseValidTo}
                </p>
              </div>
            ) : (
              ""
            )}

            {props.foundUser.Type === "Student" ? (
              <div className="align-items-baseline">
                <p className="lead float-start ms-3 mb-0 pb-0">
                  {props.foundUser.Licenses.length > 1 ? (
                    <FormattedMessage id="Licenses" />
                  ) : (
                    <FormattedMessage id="License" />
                  )}
                  :{" "}
                </p>
                {props.foundUser.Licenses.map(function (courselicense, index) {
                  return (
                    <Badge
                      color="light"
                      className="m-1 ms-3"
                      key={`class_${index}`}
                    >
                      {courselicense}
                    </Badge>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        </Col>
      </Row>
    );
  } else {
    return (
      <Row>
        <Col xs="12">
          <div className="card card-body mt-3" style={{ width: "50%" }}>
            <p className="lead">{props.foundUser.failMessage}</p>
          </div>
        </Col>
      </Row>
    );
  }
}
